import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const states = [
  { name: "QLD", full: "Queensland" },
  { name: "NSW", full: "New South Wales" },
  { name: "VIC", full: "Victoria" },
  { name: "SA", full: "South Australia" },
];

export function DeliverySection() {
  return (
    <section className="py-12 bg-muted/30 border-y border-border">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <MapPin className="h-5 w-5 text-primary" />
            <h3 className="text-xl font-bold text-foreground">
              Delivery Available Across QLD, NSW, VIC & SA
            </h3>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mb-4">
            {states.map((state, index) => (
              <motion.div
                key={state.name}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2"
              >
                <div className="h-2 w-2 rounded-full bg-primary" />
                <span className="text-sm font-medium text-foreground">{state.full}</span>
              </motion.div>
            ))}
          </div>

          <p className="text-sm text-muted-foreground">
            Delivery availability depends on product and location
          </p>
        </motion.div>
      </div>
    </section>
  );
}
